import { NoInput } from '@models/modal';
import {
  createModalDataToken,
  createModalOpener
} from 'src/app/helpers/create-modal-opener';
import { FeedbackModalComponent } from './feedback-modal.component';

export const FEEDBACK_MODAL_DATA =
  createModalDataToken<NoInput>('FeedbackModalData');

export const feedbackModalOpener = createModalOpener<
  FeedbackModalComponent,
  NoInput
>(FeedbackModalComponent, FEEDBACK_MODAL_DATA, {
  size: 'lg',
  backdrop: 'static',
  keyboard: false,
  scrollable: true,
  centered: true
});
